import { memo } from "react";
import Box from "@mui/material/Box";
import { styles } from "./title";
import { useRouter } from "next/router";

function Title({ title, children, h1, h2, aos = "fade-up", aosDelay }) {
  const router = useRouter();
  const { locale } = router;

  const Component = h1 ? h1 : h2 ? h2 : "h3";
  const text = title ?? children;

  return (
    <Box
      sx={styles.container}
      {...(aos ? { "data-aos": aos } : {})}
      {...(aosDelay != null ? { "data-aos-delay": aosDelay } : {})}
    >
      <Box
        sx={{
          position: "relative",
          display: "inline-block",
          pb: "20px",
        }}
      >
        <Box sx={styles.title} component={Component}>
          {text}
        </Box>

        <Box
          component="img"
          src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/line-main.webp"
          alt=""
          aria-hidden="true"
          loading="lazy"
          decoding="async"
          fetchpriority="low"
          sx={{
            position: "absolute",
            left: 0,
            bottom: 0,
            width: "100%",
            height: { xs: "6px", lg: "7px" },
            transform: locale === "en" ? "scaleX(-1)" : "scaleX(1)",
            display: "block",
          }}
        />
      </Box>
    </Box>
  );
}

export default memo(Title);
